<template>
  <div
    class="home d-flex flex-column"
    data-testid="elem_u_000061"
  >
    <div
      class="block-container hidden"
      data-testid="elem_u_003136"
    >
      <MainBanner
        class="home-page-item"
        :sites="sites"
        data-testid="elem_u_003137"
      />
    </div>
    <div
      class="block-container bright hidden"
      data-testid="elem_u_003138"
    >
      <Features
        class="home-page-item"
        data-testid="elem_u_003139"
      />
    </div>
    <div
      class="block-container dark hidden"
      data-testid="elem_u_003140"
    >
      <Network
        class="home-page-item"
        data-testid="elem_u_003141"
      />
    </div>
    <div
      class="block-container bright"
      data-testid="elem_u_003142"
    >
      <Programs
        class="home-page-item"
        :numberOfSites="sites.length"
        data-testid="elem_u_003143"
      />
    </div>
    <div
      class="block-container dark hidden"
      data-testid="elem_u_003144"
    >
      <Start
        class="home-page-item"
        data-testid="elem_u_003145"
      />
    </div>
  </div>
</template>

<script>
import MainBanner from './components/MainBanner';
import Features from './components/Features';
import Network from './components/Network';
import Programs from './components/Programs';
import Start from './components/Start';

export default {
  components: {
    MainBanner,
    Features,
    Network,
    Programs,
    Start,
  },

  data() {
    return {
      sites: [
        // {
        //   name: 'vrporn',
        //   srcDesktop: require('@/assets/img/home/main-banner/site-images/desktop/vrporn.png'),
        //   srcMobile: require('@/assets/img/home/main-banner/site-images/mobile/vrporn.png'),
        //   icon: require('@/assets/img/home/main-banner/site-icons/vrporn.svg'),
        // },
        {
          name: 'vrbangers',
          srcDesktop: require('@/assets/img/home/main-banner/site-images/desktop/vrbangers.jpg'),
          srcMobile: require('@/assets/img/home/main-banner/site-images/desktop/vrbangers.jpg'),
          icon: require('@/assets/img/home/main-banner/site-icons/vrbangers.svg'),
        },
        {
          name: 'dezyred',
          srcDesktop: require('@/assets/img/home/main-banner/site-images/desktop/dezyred.jpg'),
          srcMobile: require('@/assets/img/home/main-banner/site-images/desktop/dezyred.jpg'),
          icon: require('@/assets/img/home/main-banner/site-icons/dezyred.svg'),
        },
        {
          name: 'vrconk',
          srcDesktop: require('@/assets/img/home/main-banner/site-images/desktop/vrconk.jpg'),
          srcMobile: require('@/assets/img/home/main-banner/site-images/desktop/vrconk.jpg'),
          icon: require('@/assets/img/home/main-banner/site-icons/vrconk.svg'),
        },
        {
          name: 'blowvr',
          srcDesktop: require('@/assets/img/home/main-banner/site-images/desktop/blowvr.jpg'),
          srcMobile: require('@/assets/img/home/main-banner/site-images/desktop/blowvr.jpg'),
          icon: require('@/assets/img/home/main-banner/site-icons/blowvr.svg'),
        },
        {
          name: 'vrbtrans',
          srcDesktop: require('@/assets/img/home/main-banner/site-images/desktop/vrbtrans.jpg'),
          srcMobile: require('@/assets/img/home/main-banner/site-images/desktop/vrbtrans.jpg'),
          icon: require('@/assets/img/home/main-banner/site-icons/vrbtrans.svg'),
        },
        {
          name: 'vrbgay',
          srcDesktop: require('@/assets/img/home/main-banner/site-images/desktop/vrbgay.jpg'),
          srcMobile: require('@/assets/img/home/main-banner/site-images/desktop/vrbgay.jpg'),
          icon: require('@/assets/img/home/main-banner/site-icons/vrbgay.svg'),
        },
        {
          name: 'vrsmash',
          srcDesktop: require('@/assets/img/home/main-banner/site-images/desktop/vrsmash.jpg'),
          srcMobile: require('@/assets/img/home/main-banner/site-images/desktop/vrsmash.jpg'),
          icon: require('@/assets/img/home/main-banner/site-icons/vrsmash.svg'),
        },
        {
          name: 'arporn',
          srcDesktop: require('@/assets/img/home/main-banner/site-images/desktop/arporn.jpg'),
          srcMobile: require('@/assets/img/home/main-banner/site-images/desktop/arporn.jpg'),
          icon: require('@/assets/img/home/main-banner/site-icons/arporn.svg')
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.home {
  min-height: 100vh;
  padding-bottom: 30px;

  @include md-down {
    padding-bottom: 30px;
  }

  .block-container {
    width: 100vw;
    overflow: hidden;
    display: flex;
    justify-content: center;

    .home-page-item {
      max-width: 1660px;
      width: 100%;

      @media (max-width: 1660px) {
        padding-left: 22px;
        padding-right: 22px;
      }

      @include sm-down {
        padding-left: 15px;
        padding-right: 15px;
      }
    }
  }

  .bright {
    background-color: var(--color-grey-900);
  }

  .hidden {
    overflow: hidden;
  }
}
</style>

<style lang="scss">
.home {
  .home-footer {
    .footer__content {
      padding: 14px 0 0;
    }
  }
}
</style>
